<template>
  <b-modal id="dossierModal" ref="dossierModal" scrollable body-class="dossier-modal-body-scroll" @hide="close" @show="loadPipelinesForForm">
    <template #modal-header>
      <h5>{{ $t("NEW") }} {{ $t("Dossier") }}</h5>
      <b-button size="sm" @click="resetModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.028"
          height="17.028"
          viewBox="0 0 17.028 17.028"
        >
          <path
            id="Icon_material-close"
            data-name="Icon material-close"
            d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
            transform="translate(-7.5 -7.5)"
            fill="#393939"
          />
        </svg>
      </b-button>
    </template>

    <form @submit.prevent="addPRE">
      <div class="center">
        <b-form-group :label="$t('NAME') + '*'" label-for="name">
          <b-form-input
            id="name"
            v-model="v$.newDossier.name.$model"
            :state="validateState('name')"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="name-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.newDossier.name.$errors"
            id="name-feedback"
          ></error-handle>
          <div v-if="erreurlist.name" class="error-message">
            <ul v-if="Array.isArray(erreurlist.name)">
              <span v-for="(e, index) in erreurlist.name" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.name }}</span>
          </div>
        </b-form-group>

        <!-- Entreprise : uniquement pour super-admin -->
        <b-form-group v-if="isSuperAdmin" :label="$t('COMPANY_ID') + '*'" label-for="entreprise">
          <multiselect
            id="entreprise"
            v-model="selectedEntreprise"
            :searchable="true"
            :close-on-select="true"
            :multiple="false"
            :options="getAllentreprises || []"
            label="lib"
            track-by="id"
            :placeholder="$t('COMPANY_ID')"
            :loading="getentrepriseLoading"
            @open="loadEntreprises"
            @select="onEntrepriseSelect"
          >
          </multiselect>
          <div v-if="erreurlist.entreprise" class="error-message">
            {{ erreurlist.entreprise }}
          </div>
        </b-form-group>

        <b-form-group :label="$t('CUSTOMER') + '*'">
          <searchInput
            :list="getAllclients"
            :loader="getclientLoading"
            label="nom"
            :multiple="false"
            :searchFunc="all_clients"
            @searchfilter="selectClient($event)"
            :placeholder="$t('CUSTOMER')"
            :filtre="clientFiltre"
          >
          </searchInput>
          <div v-if="erreurlist.client" class="error-message">
            <ul v-if="Array.isArray(erreurlist.client)">
              <span v-for="(e, index) in erreurlist.client" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.client }}</span>
          </div>
          <div v-if="v$.newDossier.client.$error" class="error-message">
            {{ $t("REQUIRED_FIELD") }}
          </div>
        </b-form-group>

        <b-form-group :label="$t('Description')" label-for="description">
          <b-form-textarea
            id="description"
            v-model="v$.newDossier.description.$model"
            :state="validateState('description')"
            :placeholder="$t('Description')"
            maxlength="1000"
            rows="3"
          ></b-form-textarea>
          <error-handle
            :list="v$.newDossier.description.$errors"
            id="description-feedback"
          ></error-handle>
        </b-form-group>

        <b-form-group :label="$t('STATUS') || 'Statut'" label-for="status">
          <multiselect
            id="status"
            v-model="selectedStatus"
            :searchable="true"
            :close-on-select="true"
            :multiple="false"
            :options="statusOptions"
            label="text"
            track-by="value"
            :placeholder="$t('STATUS') || 'Statut'"
            :loading="getPipelineLoading"
            @open="loadPipelinesForForm"
            @select="onStatusSelect"
          >
          </multiselect>
        </b-form-group>

        <b-form-group :label=" 'Sous statut'" label-for="sousStatus">
          <multiselect
            id="sousStatus"
            v-model="selectedSousStatus"
            :searchable="true"
            :close-on-select="false"
            :multiple="true"
            :options="sousStatusOptions"
            label="text"
            track-by="value"
            :placeholder="'Sélectionnez des sous statuts...'"
          >
          </multiselect>
        </b-form-group>
      </div>
    </form>
    <template #modal-footer>
      <b-alert variant="warning" show v-if="errorS">
        {{ errorS }}
      </b-alert>
      <div class="double">
        <b-button variant="danger" @click="resetModal()">
          <div class="block-spinner">
            {{ $t("CANCEL") }}
          </div>
        </b-button>
        <b-button variant="success" @click="addPRE">
          <div class="block-spinner">
            {{ $t("SAVE") }}
            <div v-if="getLoadingdossier" class="loading ml-2">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { domains } from "@/environment";
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength } from "@vuelidate/validators";
import errorHandle from "../ui/errorHandle.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    errorHandle,
    Multiselect,
    searchInput: () => import("@/components/ui/searchInput"),
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      erreurlist: {
        name: null,
        entreprise: null,
        client: null,
      },
      newDossier: {
        name: null,
        client: null,
        description: null,
      },
      selectedEntreprise: null,
      selectedStatus: null,
      selectedSousStatus: [],
      galleryUrl: domains.gallery,
      page: 1,
      per_page: 1000,
      errorS: false,
      box: "",
    };
  },
  validations() {
    return {
      newDossier: {
        name: { required, maxLength: maxLength(100) },
        client: { required },
        description: { maxLength: maxLength(1000) },
      },
    };
  },
  methods: {
    ...mapActions(["store_dossier", "all_clients", "all_entreprises", "loadPipelinesForFormFromProcessus", "fetchActiveProcessusByEntreprise"]),

    validateState(name) {
      const { $dirty, $error } = this.v$.newDossier[name];
      return $dirty ? !$error : null;
    },

    loadEntreprises() {
      if ((this.getAllentreprises || []).length === 0) {
        this.all_entreprises({ page: 1, per_page: 1000 });
      }
    },
    async loadPipelinesForForm() {
      try {
        const entrepriseId = this.isSuperAdmin
          ? (this.selectedEntreprise && this.selectedEntreprise.id)
          : (this.getOnlineUser?.entreprise?.id ?? this.getOnlineUser?.entreprise);
        if (!entrepriseId) return;
        const processusId = await this.fetchActiveProcessusByEntreprise(entrepriseId);
        if (!processusId) return;
        await this.loadPipelinesForFormFromProcessus({
          processus_id: processusId,
          entreprise_id: entrepriseId,
        });
      } catch (e) {
        console.warn("Pipeline load failed", e);
      }
    },
    onStatusSelect() {
      this.selectedSousStatus = [];
    },

    onEntrepriseSelect() {
      this.newDossier.client = null;
      this.all_clients({
        page: 1,
        per_page: this.per_page,
        entreprise_id: this.selectedEntreprise ? this.selectedEntreprise.id : null,
      });
    },

    async addPRE() {
      if (this.isSuperAdmin && !this.selectedEntreprise) {
        this.erreurlist.entreprise = this.$t("REQUIRED_FIELD") || "Champ obligatoire";
        return;
      }
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.errorS = null;
      this.erreurlist = { name: null, entreprise: null, client: null };
      const entrepriseId = this.isSuperAdmin
        ? (this.selectedEntreprise && this.selectedEntreprise.id)
        : (this.getOnlineUser.entreprise && this.getOnlineUser.entreprise.id);
      const pipelineId = this.selectedStatus ? (this.selectedStatus.value ?? this.selectedStatus.id) : null;
      const sousPipelineIds = Array.isArray(this.selectedSousStatus)
        ? this.selectedSousStatus.map((s) => s.value ?? s.id).filter(Boolean)
        : [];
      const data = {
        name: this.newDossier.name,
        client_id: this.newDossier.client.id,
        entreprise_id: entrepriseId,
        ocr_delegataire_id: null,
        description: this.newDossier.description || null,
        pipeline_id: pipelineId,
        sous_pipeline_ids: sousPipelineIds,
      };
      await this.store_dossier(data)
        .then(() => {
          this.resetModal();
          this.$emit("updateList");
        })
        .catch((err) => {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              if (!this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorS = err;
          }
        });
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    resetModal() {
      this.errorS = null;
      this.$refs["dossierModal"].hide();
      this.newDossier = { name: null, client: null, description: null };
      this.selectedEntreprise = null;
      this.selectedStatus = null;
      this.selectedSousStatus = [];
      this.$nextTick(() => {
        this.v$.$reset();
      });
      this.erreurlist = { name: null, entreprise: null, client: null };
    },

    close(bv) {
      if (this.$refs["dossierModal"].isShow) {
        if (bv.trigger == "backdrop") {
          bv.preventDefault();
          this.showMsgBox();
        }
      }
    },

    showMsgBox() {
      this.box = "";
      this.$bvModal
        .msgBoxConfirm(`${this.$t("CLOSE")}`, {
          title: `${this.$t("CONFIRM")}`,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: `${this.$t("YES")}`,
          cancelTitle: `${this.$t("NO")}`,
          footerClass: "p-2",
          hideHeaderClose: false,
        })
        .then((value) => {
          if (value) {
            this.resetModal();
          }
        });
    },

    selectClient(item) {
      this.newDossier.client = item;
    },
  },
  mounted() {
    if (this.isSuperAdmin) {
      this.loadEntreprises();
    }
    if (!this.isSuperAdmin && this.getOnlineUser.entreprise) {
      this.all_clients({
        page: this.page,
        per_page: this.per_page,
        entreprise_id: this.getOnlineUser.entreprise.id,
      });
    }
  },
  watch: {
    selectedEntreprise() {
      this.selectedStatus = null;
      this.selectedSousStatus = [];
      this.loadPipelinesForForm();
    },
  },
  computed: {
    ...mapGetters([
      "getLoadingdossier",
      "getOnlineUser",
      "getAllclients",
      "getclientLoading",
      "getAllentreprises",
      "getentrepriseLoading",
      "getPipelinesForForm",
      "getPipelineLoading",
    ]),
    statusOptions() {
      const list = this.getPipelinesForForm || [];
      return list.map((p) => ({
        value: p.id,
        text: p.name || "-",
        ...p,
      }));
    },
    sousStatusOptions() {
      const pipeline = this.selectedStatus;
      const sousList = pipeline?.sous_pipelines || [];
      return sousList.map((ss) => ({
        value: ss.id,
        text: ss.name || "-",
        ...ss,
      }));
    },
    isSuperAdmin() {
      return this.getOnlineUser && this.getOnlineUser.role === "user.super-admin";
    },
    clientFiltre() {
      const entrepriseId = this.isSuperAdmin
        ? (this.selectedEntreprise && this.selectedEntreprise.id)
        : (this.getOnlineUser.entreprise && this.getOnlineUser.entreprise.id);
      return { entreprise_id: entrepriseId || undefined };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog-scrollable .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
.option {
  display: flex;
  align-items: center;
  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}
</style>
